export const environment = {
  production: true,
  name: 'prod',
  imageBucket: 'pocketlab-user-uploads',
  messageBucket: 'pocketlab-user-messages',
  scormBucket: 'pocketlab-user-scorm',
  imageCloudFrontUrl: 'https://app.thepocketlab.com/user-uploads/',
  messageCloudFrontUrl: 'https://app.thepocketlab.com/user-messages/',
  scormCloudFrontUrl: 'https://app.thepocketlab.com/user-scorm/',
  // websocketAPIGatewayUrl: 'wss://xxtzns5bj6.execute-api.us-east-1.amazonaws.com/ProdStage',
  websocketAPIGatewayUrl: 'wss://ws.thepocketlab.com',
  entryAPIGatewayUrl: 'https://app.thepocketlab.com/api',
  host: 'https://app.thepocketlab.com',
  entryAPIGatewayName: 'EntryGatewayProd',
  errorReportAPIEndpointName: 'ErrorReportGatewayProd',
  errorReportAPIEndpointUrl: 'https://app.thepocketlab.com/api/error',
  identityPoolId: 'us-east-1:f354e156-5543-4559-9786-6eae5b36cba3',
  userPoolId: 'us-east-1_PW0QaFILD',
  userPoolWebClientId: '4b8n51df3c414tcum1c45npe1i',
  oAuthDomain: 'notebook-prod.auth.us-east-1.amazoncognito.com',
  oneRosterAPIGatewayName: 'OneRosterGatewayProd',
  oneRosterAPIGatewayUrl: 'https://app.thepocketlab.com/api/oneroster',
  opensearchAPIGatewayName: 'OpensearchGatewayProd',
  opensearchAPIGatewayUrl: 'https://app.thepocketlab.com/api/opensearch',
  searchEnabled: true,
  userStatsAPIGatewayName: 'UserStatsGatewayProd',
  userStatsAPIGatewayUrl: 'https://app.thepocketlab.com/api/stats',
  authAPIGatewayName: 'AuthGatewayProd',
  authAPIGatewayUrl: 'https://auth.thepocketlab.com',
  posthogApiKey: 'phc_H9Yf3IFyIxNlr42YLOjlocfH4AYVitAZLrvdzL6fiPx',
  customAuthCurricula: {'6jxTniMN0008lxdS': 'QMj_uFNZ0009j7Xr'},
};
